module.exports = __webpack_public_path__ + "static/6305-woodrose-11-27a33c7d4ad01881d11141a0bf742c3d.jpg";